module.exports = __webpack_public_path__ + "static/media/soono-social.f0c299a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soono-social.png
// module id = 1219
// module chunks = 0